import { api } from './_request';

 export const get = () => {
 	return (dispatch) => {

 		api().get('/select/clientes').then(function(response) {
			if(response.status === 200) {
				dispatch({
				type: 'CLIENTE_LIST',
					payload: response.data
 				});
			}
 		});

 	}
 };

 export const get_usuarios = (id) => {
 	return (dispatch) => {

 		api().get('usuario/'+id).then(function(response) {
			if(response.status === 200) {
				dispatch({
				type: 'USUARIOS_LIST',
					payload: response.data
 				});
			}
 		});

 	}
 };

export const save_cliente = (item, callback) => {
	return (dispatch) => {

		dispatch({ type: 'CLIENTE_SAVE' });

		api().post('cliente', item).then(function(response) {

			if(response.status === 200) {

				dispatch({
					type: 'CLIENTE_SAVE_SUCCESS',
					payload: response.data
				});

				if(typeof callback === 'function') callback(response.data);

			}
			else{
				dispatch({ type: 'CLIENTE_SAVE_FAILURE' });
			}

		})
		.catch(function(error) {
			dispatch({ type: 'CLIENTE_SAVE_FAILURE' });
		});

	}
};

export const update_cliente = (cliente, callback) => {
	return (dispatch) => {

        
		dispatch({ type: 'CLIENTE_SAVE' });

		api().post(`cliente/${cliente.id}`, cliente)
		.then(function(response)
		{
			if(response.status === 200)
			{
				dispatch({
					type: 'CLIENTE_UPDATE_SUCCESS',
					payload: response.data
				});
				console.log('cliente action----->', response.data);

				if(typeof callback === 'function') callback(response.data);
			}
			else
			{
				dispatch({ type: 'PROSPECT_SAVE_FAILURE' });
			}
		})
		.catch(function(error) {
			dispatch({ type: 'PROSPECT_SAVE_FAILURE' });
		});

	}
};

export const save_usuario = (item, callback) => {
	return (dispatch) => {

		dispatch({ type: 'CLIENTE_SAVE' });

		api().post('usuario', item).then(function(response) {

			if(response.status === 200) {

console.log( response.data);
				dispatch({
					type: 'USUARIO_SAVE_SUCCESS',
					payload: response.data
				});

				if(typeof callback === 'function') callback(response.data);

			}
			else{
				dispatch({ type: 'CLIENTE_SAVE_FAILURE' });
			}

		})
		.catch(function(error) {
			dispatch({ type: 'CLIENTE_SAVE_FAILURE' });
		});

	}
};


// WEBPACK FOOTER //
// ./src/actions/cliente.js